import {styled} from "@mui/material/styles";
import {Box, Button, ButtonGroup, Grid, Typography} from "@mui/material";

export const PaymentModalBoxStyles = styled(Box)(({theme}) => ({
  width: '100%',
  backgroundColor: '#FFFFFF',
  height: '35em',
  borderRadius: '0.5em',
  boxShadow: '0px 9px 46px 8px #0000001F',
  position: ' absolute',
  top: '50%',
  left: '42%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('sm')]: {
    width: '38.37em',
    height: 'auto',
    maxHeight: '90vh',
  }
}));

export const PaymentModalStickyTop = styled(Box)(() => ({
  position: 'sticky',
  top: 0,
  padding: '1.5em 1.5em .2em 1.5em',
}));

export const PaymentModalFullContent = styled(Grid)(() => ({
  flex: '1',
  overflowY: 'scroll',
}));

export const PaymentModalTitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '1.14em',
  fontWeight: '500',
  lineHeight: '1.78em',
  marginBottom: '1.5em',
}));

export const PaymentModalSubtitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '1.14em',
  fontWeight: '500',
  lineHeight: '1.78em',
  marginBottom: '0.3em',
}));

export const PaymentModalWrapper = styled(Grid)(() => ({
  width: '100%',
}));

export const PaymentModalButtonGroup = styled(ButtonGroup)(() => ({
  backgroundColor: 'rgba(245, 245, 245, 1)',
  justifyContent: 'flex-end',
  alignItems: 'center',
  display: 'flex',
  height: '3.71em',
  width: '100%',
}));

export const PaymentModalButton = styled(Button)(() => ({
  border: 'none !important',
  outline: 'none',
  backgroundColor: 'transparent',
  '&:hover': {
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
  },
}));

export const PaymentModalContentWrap = styled(Box)(() => ({
  padding: '0em 1.5em .2em 1.5em',
}));
